export default __webpack_public_path__ + "static/media/landing.11ce4f2a.jpg";